<div class="flex relative overflow-hidden z-50">
  <!-- Sidebar -->
  <div [ngClass]="[
      sidebarCollapsed ? 'w-20' : 'w-64',
      'h-screen fixed top-0 left-0 bg-slate-900 text-white transition-all duration-500 ease-in-out'
    ]" [@myInsertRemoveTrigger]>
    <div class="flex flex-col h-full">

      <!-- Logo -->
      <div class="flex items-center justify-center mt-4 shrink-0">
        @if (!sidebarCollapsed) {
        <img class="logo w-3/4 transition-all duration-500 ease-in-out" src="assets/logos/DMANALYTICS-1.png"
          alt="logo dmanalytics" />
        }
        @else {
        <img class="logo mb-3 w-12 transition-all duration-500 ease-in-out" src="assets/logos/just_icon_logo.png"
          alt="logo dmanalytics" />
        }
      </div>

      <hr class="h-px mt-1 mb-6 bg-gray-600 border-0 shrink-0" />

      <!-- Menu com scroll -->
      <div class="flex-1 overflow-y-auto overflow-x-hidden">
        <nav class="navbar">
          <ul class="nav">
            @for (item of carregarMenu(); track item.idmenu) {
            <ng-container>
              @if (item.subitem && item.subitem.length > 0) {
              @if (!sidebarCollapsed) {
              <!-- Menu com Dropdown Expandido -->
              <mat-expansion-panel class="!bg-transparent !shadow-none !text-white border-none"
                style="border-radius:0 !important">
                <mat-expansion-panel-header
                  class="h-10 px-4 !min-h-0 !rounded-none !text-white hover:!bg-slate-800 transition-all duration-200">
                  <mat-panel-title class="!text-white flex items-center gap-2 w-full font-normal text-sm">
                    <mat-icon class="material-symbols-outlined text-[18px] mt-[5px]">{{ item.iconemenu }}</mat-icon>
                    {{ item.nomemenu }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngFor="let sub of item.subitem">
                  <a [routerLink]="[sub.url]" appLinkLoading 
                      routerLinkActive="active-submenu"
                      [routerLinkActiveOptions]="{ exact: false }"
                    class="flex items-center gap-2 px-6 py-[6px] text-[0.75rem] font-light font-poppins transition-all duration-200 hover:text-white text-gray-400">
                    <mat-icon class="material-symbols-outlined text-[18px] mt-[5px]">{{ sub.iconemenu }}</mat-icon>
                    {{ sub.nomemenu }}
                  </a>
                </div>
              </mat-expansion-panel>
              }
              @else {
              <!-- Sidebar colapsada com submenu flutuante -->
              <li
                class="relative group flex items-center justify-center itens_menu navbar-item !p-2 transition-all duration-300 hover:bg-white">
                <div class="group relative">
                  <div class="flex items-center justify-center">
                    <mat-icon class="material-symbols-outlined text-white text-[18px] !mt-[5px]">{{ item.iconemenu }}</mat-icon>
                  </div>
                  <div
                    class="fixed top-1/2 -translate-y-1/2 left-[60px] z-[999] bg-slate-900 text-white shadow-lg rounded-md min-w-[200px] opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-opacity duration-300">

                    <ul class="py-2">
                      <li *ngFor="let sub of item.subitem">
                        <a [routerLink]="[sub.url]" appLinkLoading
                          routerLinkActive="active-submenu"
                          [routerLinkActiveOptions]="{ exact: false }"
                          class="flex items-center gap-2 px-6 py-[6px] text-[0.75rem] font-light font-poppins transition-all duration-200 hover:text-white">
                          <mat-icon class="material-symbols-outlined text-[18px] mt-[5px]">{{ sub.iconemenu }}</mat-icon>
                          {{ sub.nomemenu }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              }
              }
              @else {
              <!-- Menu sem subitem -->
              <a [routerLink]="[item.url]" appLinkLoading [matTooltip]="item.nomemenu" [matTooltipDisabled]="!sidebarCollapsed"
                matTooltipClass="custom-tooltip" matTooltipPosition="right"
                routerLinkActive="active-menu"
                [routerLinkActiveOptions]="{ exact: false }">
                <li
                  class="flex items-center gap-2 px-4 py-2 text-sm text-white hover:bg-slate-800 transition-all duration-200 rounded-md justify-center"
                  *ngIf="sidebarCollapsed">
                  <mat-icon class="material-symbols-outlined text-[20px] !mt-[5px]">{{ item.iconemenu }}</mat-icon>
                </li>
                <li
                  class="flex items-center gap-2 px-4 py-2 text-sm text-white hover:bg-slate-800 transition-all duration-200 rounded-md"
                  *ngIf="!sidebarCollapsed">
                  <mat-icon class="material-symbols-outlined text-[18px] mt-[5px]">{{ item.iconemenu }}</mat-icon>
                  <span>{{ item.nomemenu }}</span>
                </li>
              </a>
              }
            </ng-container>
            }
            @empty {
            <li class="px-4 py-2 text-sm text-gray-300">Carregando...</li>
            }
          </ul>
        </nav>
      </div>

      <!-- Rodapé -->
      <div class="sidebar-footer w-full shrink-0 flex items-center justify-center gap-2 px-4 py-2"
        *ngIf="!sidebarCollapsed">
        <p class="text-[10px] font-light">
          © Copyright - <a href="https://demarco.com.br" target="_blank"
            class="text-demarco font-bold no-underline hover:underline">Demarco &amp; CO</a>
        </p>
        <a href="https://demarco.com.br" target="_blank" aria-label="Logo Demarco & CO">
          <img src="assets/logos/demarco-ico.svg" alt="Logo Demarco & CO" width="20px" />
        </a>
      </div>

      <!-- Versão colapsada -->
      <div class="sidebar-footer w-full shrink-0 flex items-center justify-center py-3" *ngIf="sidebarCollapsed">
        <a href="https://demarco.com.br" target="_blank" aria-label="Logo Demarco & CO">
          <img src="assets/logos/demarco-ico.svg" alt="Logo Demarco & CO" width="20px" />
        </a>
      </div>


    </div>
  </div>
</div>